module.exports = __webpack_public_path__ + "static/media/soat.fe87a942.png";